module.exports = __webpack_public_path__ + "vue_assets/img/img_header_forest.c3618a1a.jpg";